// One semantic table and one set of controls at every width. Supply a plain-text
// label on each cell; phones show it beside the value, desktop uses the thead.
export default function ResponsiveTable({ children, className = '', ...props }) {
    return <table className={`ia-responsive-table ${className}`} {...props}>{children}</table>;
}
export function ResponsiveCell({ label, children, ...props }) {
    return <td data-label={label} {...props}><div className="ia-responsive-value">{children}</div></td>;
}
